exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vs-table__header {\n  background: none;\n}", ""]);

// exports
